export default __webpack_public_path__ + "static/media/illustrator-logo.600b6331.svg";